import { useEffect } from 'react';
import { InfoIcon } from '../../components/error-popup-handler/InfoIcon';
import './ServiceUnavailablePage.scss';

export const ServiceUnavailablePage = () => {
  useEffect(() => {
    document.title = 'Technician CoPilot – Service Unavailable';
  }, []);

  return (
    <main className='service-unavailable'>
      <section
        className='service-unavailable__card'
        aria-labelledby='service-unavailable-title'
      >
        <p className='service-unavailable__brand'>
          ASSA ABLOY - Technician CoPilot
        </p>
        <div className='service-unavailable__icon'>
          <InfoIcon aria-hidden='true' />
        </div>
        <h1
          id='service-unavailable-title'
          className='service-unavailable__title'
        >
          Technician CoPilot is temporarily unavailable
        </h1>
        <p className='service-unavailable__text'>
          Technician CoPilot is currently experiencing technical difficulties.
        </p>
        <p className='service-unavailable__text'>
          Our team is aware of the issue and is actively working to restore the
          service as soon as possible.
        </p>
        <p className='service-unavailable__text'>
          We apologize for the inconvenience and appreciate your patience and
          understanding.
        </p>
        <p className='service-unavailable__thanks'>
          Thank you for your patience.
        </p>
        <p className='service-unavailable__signature'>
          — The Technician CoPilot Team
        </p>
      </section>
    </main>
  );
};
